import { useSelector } from 'react-redux'


const useCheckPermission = () => {
  const accessPermission = useSelector(state => state.auth.accessPermissions);

  const normalizePath = (path) => {
    if (!path) return '';
    return path.replace(/^\/+|\/+$/g, '');
  }
  const checkPermission = (url) => {
    if (!accessPermission) return false;
    const normalizedUrl = normalizePath(url);
    return accessPermission?.some(item =>
      normalizePath(item.path) === normalizedUrl
    );
  }
  return checkPermission;
}

export default useCheckPermission;
